import Vue from 'vue'
import Vuex from 'vuex'
//
import modules from './modules'
//
Vue.use(Vuex)
//
export default new Vuex.Store({
	state: {
		referal: false,
		partner: false
	},

	mutations: {
		setReferal (state, referal) {
			state.referal = referal
		},

		setPartner (state, partner) {
			state.partner = partner
		},
	},

  modules
})



// WEBPACK FOOTER //
// ./src/store/index.js